import { Component, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { InfoService } from '@app/core/info/info.service';
import { ActivationData, ActivationStatusStep, ActivationStep } from './activation.model';
import { ActivatedRoute } from '@angular/router';
import { ActivationService } from './services/activation.service';

@Component({
  selector: 'cloud-activation',
  templateUrl: './activation.component.html',
  styleUrls: ['./activation.component.scss', './activation.component-theme.scss']
})
export class ActivationComponent implements OnInit {

  nextStep: ActivationStep = ActivationStep.BISS;
  uuid:string;

  activationData: ActivationData;
  fullActivationData: ActivationData[];

  constructor(  
    public info: InfoService,
    private translateService: TranslateService,
    private activationService: ActivationService,
    private router:ActivatedRoute) { 
    this.uuid = this.router.snapshot.params['uuid']
    
    }

  ngOnInit() {
    this.setActivationData();
  }

  openNextStep(event: any) {
    if (event == ActivationStep.BISS) {
      if (this.activationData.status != null) {
        this.nextStep = ActivationStep.DOCUMENTS;
      } else {
        this.nextStep = ActivationStep.OTP;
      }
      return;
    }
    if (event == ActivationStep.OTP) {
      this.nextStep = ActivationStep.PIN;
      return;
    }
    if (event == ActivationStep.PIN) {
      this.nextStep = ActivationStep.DOCUMENTS;
      return;
    }
  }

  isBissStep() {
    return this.nextStep == ActivationStep.BISS;
  }
  isOTPStep() {
    return this.nextStep == ActivationStep.OTP;
  }
  isPINStep() {
    return this.nextStep == ActivationStep.PIN;
  }
  isDocumentStep() {
    return this.nextStep == ActivationStep.DOCUMENTS;
  }

  
  setActivationData(){
    this.activationService.getActivationData(this.uuid).subscribe((r)=>{
      this.activationData = r.data[0];
      this.fullActivationData = r.data;
    })
  }

}
